import React from 'react';
import compact from 'lodash/compact';
import classnames from 'classnames';

import StrapiLink from '../../StrapiLink/StrapiLink';
import { TextAndSplitImagesFragment } from '../../../../graphql.schema';

import * as styles from './index.module.scss';

export const StrapiTextAndSplitImages = ({
  mainHeading,
  mainDescription,
  links,
  imageLeft,
  imageCenter,
  imageRight,
}: TextAndSplitImagesFragment) => (
  <div className={styles.textAndSplitImages}>
    <div className={classnames(styles.reverseColumns, 'columns')}>
      <div className="column is-4 is-flex is-flex-direction-column-reverse-mobile is-flex-direction-column is-justify-content-center">
        <h2 className={classnames('title is-2 brand-a mb-4', styles.mainHeading)}>{mainHeading}</h2>
        <p className="is-text-2 black-2 mb-5">{mainDescription}</p>
        <div className={styles.links}>
          {compact(links).map((link) => (
            <StrapiLink key={link?.title} {...link} className="has-text-weight-700">
              {link.title}
            </StrapiLink>
          ))}
        </div>
      </div>
      <div className="column is-7 is-offset-1">
        <div className={styles.images}>
          <img
            className={styles.imageLeft}
            alt={imageLeft?.alternativeText ?? imageLeft?.caption ?? ''}
            src={imageLeft?.url}
            width={imageLeft?.width}
            height={imageLeft?.height}
            loading="lazy"
          />
          <img
            className={styles.imageCenter}
            alt={imageCenter?.alternativeText ?? imageCenter?.caption ?? ''}
            src={imageCenter?.url}
            width={imageCenter?.width}
            height={imageCenter?.height}
            loading="lazy"
          />
          <img
            className={styles.imageRight}
            alt={imageRight?.alternativeText ?? imageRight?.caption ?? ''}
            src={imageRight?.url}
            width={imageRight?.width}
            height={imageRight?.height}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
);
